import React from 'react'
import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function BackPillButton({ to, state, onClick, children, className = '' }) {
  const navigate = useNavigate()

  const handleClick = (event) => {
    onClick?.(event)
    if (event?.defaultPrevented) return
    if (to) {
      navigate(to, { state })
    }
  }

  return (
    <button type="button" className={`mp-ghost mp-booking-back-control ${className}`.trim()} onClick={handleClick}>
      <ChevronLeft className="mp-booking-back-control__icon" size={16} aria-hidden="true" />
      {children}
    </button>
  )
}
